import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import POSCheckIn from "../pages/pos-checkin/page";
import POSCheckout from "../pages/pos-checkout/page";
import AuthCallback from "../pages/auth-callback/page";
import RequireAuth from "../auth/RequireAuth";
import AccountLogin from "../pages/account/login/page";
import SelectProfile from "../pages/account/select-profile/page";
import SilentRefresh from "../pages/silent-refresh/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/pos-checkin" replace />,
  },
  {
    path: "/account/login",
    element: <AccountLogin />,
  },
  {
    path: "/account/select-profile",
    element: (
      <RequireAuth>
        <SelectProfile />
      </RequireAuth>
    ),
  },
  {
    path: "/auth-callback",
    element: <AuthCallback />,
  },
  {
    path: "/assets/silent-refresh.html",
    element: <SilentRefresh />,
  },
  {
    path: "/pos-checkin",
    element: (
      <RequireAuth>
        <POSCheckIn />
      </RequireAuth>
    ),
  },
  {
    path: "/pos-checkout",
    element: (
      <RequireAuth>
        <POSCheckout />
      </RequireAuth>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
